"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
let Invoice = class Invoice {
    _id = (0, uuid_1.v4)();
    prefix;
    invoiceNumber;
    invoiceEntity;
    userId;
    userInvoiceInfo;
    issuedAt;
    servicedAt; // not used
    invoiceCurrency;
    baseCurrency;
    items = [];
    isVat;
    isReverseCharge;
    invoiceTotalAmount;
    totalAmount;
    rates;
    invoicingDateTo;
    invoicingDateFrom;
    get dueDate() {
        const dueDate = new Date(this.issuedAt);
        dueDate.setUTCDate(dueDate.getUTCDate() + 3);
        return dueDate;
    }
    get invoiceTotalAmountDisplay() {
        return (this.invoiceTotalAmount / 100).toFixed(2);
    }
    get totalAmountDisplay() {
        return (this.totalAmount / 100).toFixed(2);
    }
};
exports.Invoice = Invoice;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Invoice.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Invoice.prototype, "prefix", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.ValidateIf)((invoice) => invoice.totalAmount > 0),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Invoice.prototype, "invoiceNumber", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Invoice.prototype, "invoiceEntity", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Invoice.prototype, "userId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Invoice.prototype, "userInvoiceInfo", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Invoice.prototype, "issuedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Invoice.prototype, "servicedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Invoice.prototype, "invoiceCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Invoice.prototype, "baseCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], Invoice.prototype, "items", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Invoice.prototype, "isVat", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Invoice.prototype, "isReverseCharge", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Invoice.prototype, "invoiceTotalAmount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Invoice.prototype, "totalAmount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Invoice.prototype, "rates", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    transformToDate_1.TransformToDate,
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Invoice.prototype, "invoicingDateTo", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Invoice.prototype, "invoicingDateFrom", void 0);
exports.Invoice = Invoice = __decorate([
    (0, typeorm_1.Entity)("invoices")
], Invoice);
//# sourceMappingURL=Invoice.js.map